import { connect } from 'react-redux';
import SideBar from './index';
import { mapDispatchToProps, mapStateToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
